// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__JZCPt","logo":"Logo_logo__huc0j"};